import { getStore } from '../store/store';

export const isWin32IconsRegistered = (): boolean => getStore().areSmallIconsRegistered;
